import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { AppEnvService } from '../../../lib/core/services/app-env.service';
import { MessageUtils } from '../../rt-shared/utils/message-utils';

export abstract class BaseComponent {
  logger: NGXLogger;
  translateService: TranslateService;

  constructor(injector: Injector) {
    this.logger = injector.get(NGXLogger);
    this.translateService = injector.get(TranslateService);
  }

  get envConfig(): any {
    return AppEnvService.staticEnvConfig();
  }
  get today(): Date {
    return new Date();
  }

  public getMessageUtils(): MessageUtils {
    return new MessageUtils(this.translateService);
  }
}
